import { styled } from '@material-ui/core';
export const RowStyle = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    '&:not(:last-child)': {
        marginBottom: theme.spacing(2),
    },
}));
//# sourceMappingURL=index.js.map